import React from 'react';
import { BanCircleIcon, HelpIcon, Position, TickCircleIcon, Tooltip, WarningSignIcon } from 'evergreen-ui';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  iconStatus: {
    paddingLeft: '10px',
  },
});

export const IconStatus = ({ param, errors, isFetching }) => {
  const classes = useStyles();

  if (isFetching) {
    return <SuspenseSpinner size={27} />;
  }
  if (param === 'UP') {
    return (
      <Tooltip content={errors} position={Position.TOP}>
        <TickCircleIcon color="success" size={27} className={classes.iconStatus} />
      </Tooltip>
    );
  }
  if (param === 'OUT_OF_SERVICE') {
    return (
      <Tooltip content={errors} position={Position.TOP}>
        <WarningSignIcon color="warning" size={27} className={classes.iconStatus} />
      </Tooltip>
    );
  }
  if (param === 'DOWN') {
    return (
      <Tooltip content={errors} position={Position.TOP}>
        <BanCircleIcon color="danger" size={27} className={classes.iconStatus} />
      </Tooltip>
    );
  }
  if (param === 'UNKNOWN' || param === null) {
    return (
      <Tooltip content="Нет информации" position={Position.TOP}>
        <HelpIcon color="#66788a" size={27} className={classes.iconStatus} />
      </Tooltip>
    );
  }
  return null;
};
